import React from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import ApiService from '../../services/ApiService';

const layout = [
  {
    label: 'Title',
    name: 'title',
    col: 10,
    placeholder: 'Test',
  },
  {
    label: 'Public',
    name: 'isPublic',
    control: 'Checkbox',
    col: 2,
  },
  {
    label: '',
    name: 'noteBody',
    control: 'Markdown',
    required: true,
  },
];

const AddNote = ({ itemId = '', listId = '', onCancel = () => modal.close(), submitCallback = () => modal.close() }) => {
  const handleSubmit = payload => {
    payload.itemId = itemId;
    payload.listId = listId;

    return ApiService.post('/note', payload).then(() => {
      if (submitCallback) submitCallback();
    });
  };

  layout[0].placeholder = itemId ? `Note for ${itemId}` : 'New Note';

  return (
    <Form
      exportFormat="object"
      layout={[...layout]}
      onCancel={onCancel}
      showHelp={false}
      submit={handleSubmit}
      submitAll
      trackDirty={false}
    />
  );
};

AddNote.propTypes = {
  itemId: PropTypes.string,
  listId: PropTypes.string,
  submitCallback: PropTypes.func,
};

export default AddNote;
